<template>
  <div class="uniPromotion_box">
    <div class="selectDataBox uniPromotion-toolbar flex alcenter flex_wrap pb20">
      <div class="update_box flex alcenter  ">
        数据更新于 {{ updateTime }} <span class="c_primary pl5" @click="refresh">刷新</span>
      </div>
      <el-alert
        v-if="planSyncBannerVisible"
        class="uni-promotion-sync-alert"
        :title="planSyncBannerText"
        type="warning"
        :closable="false"
        show-icon>
      </el-alert>
      <el-date-picker popper-class="datePicker" class="scaled-date-picker" @change="pickData" v-model="selectData" :disabled="isAllAccountSelected"
        type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
        :picker-options="pickerOptions" format="yyyy 年 MM 月 dd 日">
      </el-date-picker>
      <div class="relative">
        <div class="selectAdBox " @click.stop="gotoShowSelectPopup(
        )">
          <div v-if="selectPopupIndex == null" class="pl5 ">请选择广告账户</div>
          <div v-else class="pl5 overflow1 c_000 ">{{ adAccountName }}</div>
          <i class=" el-icon-arrow-down"></i>
        </div>

        <div class="account_selector_popup_box" v-if="showSelectPopup">
          <div class="number_top flex alcenter">
            <el-input v-model="searchADAccount" @input="inputSearchDYNumber()" placeholder="请输入广告账户名称/ID搜索"
              prefix-icon="el-icon-search">
            </el-input>
          </div>
          <div class="select_account_all_box" @scroll="handleADAccountListScroll($event)">
            <div class="select_account_box account_box2 mb10" @click="goSelectDYNumber(index2)"
              v-for="(item, index2) in searchADAccount ? searchADAccountList : ADAccountList" :key="item.advertiserId ? (item.advertiserId + '_' + index2) : index2">
              <div class="account_left_box">
                <div class="accountNameBox">
                  <span class="name c_666">{{ item.name }}</span>
                </div>
                <div class="idBox pt20 c_999">
                  ID:{{ item.advertiserId }}
                </div>
              </div>
              <div class="account_right_box2">
                <div class="account_shop_box2 mb10">店铺</div>
                <div class="account_normal_box" :class="{ 'account_normal_box--error': isAdvertiserStatusError(item) }">
                  {{ getAdvertiserStatusText(item) }}
                </div>
              </div>
            </div>
            <div class="text-center c_999 pt10"
              v-if="searchADAccount ? searchADAccountScrollLoading : ADAccountScrollLoading">
              加载更多中...
            </div>
            <div class="text-center c_999 pt10"
              v-else-if="!(searchADAccount ? searchADAccountScrollHasMore : ADAccountScrollHasMore) && (searchADAccount ? searchADAccountList.length : ADAccountList.length)">
              已加载全部
            </div>
          </div>
        </div>
      </div>
      <el-select
        v-model="selectedGroupId"
        clearable
        filterable
        class="group-select"
        placeholder="请选择账户分组"
        :loading="groupListLoading"
        @change="handleGroupChange">
        <el-option
          v-for="item in advertiserGroupList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <!-- <el-button>搜索</el-button> -->
    </div>
    <div class="selectDataBox accountPayInfo uniPromotion-metrics flex_wrap flex-between alcenter">
      <div class="balance account_box">
        <div class="flex pb10">
          账户余额(元)
          <!-- <div>预警设置</div> -->
        </div>
        <div class="font-bold fs22"> {{ formatMetricDisplay(balance) }}</div>
        <div class="metric-detail-link metric-detail-link--placeholder">详情</div>
      </div>
      <div class="balance account_box">
        <div class="flex pb10 alcenter">
          整体消耗(元)
          <el-tooltip class="item" effect="dark" content="全域推广产品投放期间产生的消耗" placement="top">
            <i class="el-icon-question pt5 ml10"></i>
          </el-tooltip>
        </div>
        <div class="font-bold fs22 flex alcenter">
          {{ formatMetricDisplay(payInfo.stat_cost) }}
          <!-- <div class="icon2_box pl5">
            <i class="el-icon-caret-bottom"></i>
            65.83%
          </div> -->
        </div>
        <div class="metric-detail-link" @click.stop="navigateToCostOverview('consumption')">详情</div>
      </div>
      <div class="balance account_box">
        <div class="flex pb10 alcenter">
          整体支付ROI
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">ROI = 整体成交金额 /
              消耗；说明：整体成交金额<br />包含用户实际成交金额、整体成交智能优惠券金<br />额、未完结预售订单预估金额和电商平台补贴金额<br />（如电商平台补贴金额没有具体值，则代表当前尚<br />未统计，请等待数据回溯）
            </div>
            <i class="el-icon-question pt5 ml10"></i>
          </el-tooltip>
        </div>
        <div class="font-bold fs22 flex alcenter">
          {{ formatMetricDisplay(payInfo.total_prepay_and_pay_order_roi2) }}
          <!-- <div class="icon2_box icon3_box pl5">
            <i class="el-icon-caret-top"></i>
            28.77%
          </div> -->
        </div>
        <div class="metric-detail-link metric-detail-link--placeholder">详情</div>
      </div>
      <div class="balance account_box">
        <div class="flex pb10 alcenter">
          用户实际支付金额(元)
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">全域推广产品投放期间，推广商品在推广渠道下产<br />生的成交订单金额
              （包含非预售订单的成交金额和<br />预售订单已完成尾款支付金额，不包含预售订单未<br />完成尾款支付金额以及直播间内的商品成交金额）
            </div>
            <i class="el-icon-question pt5 ml10"></i>
          </el-tooltip>
        </div>
        <div class="font-bold fs22 flex alcenter">
          {{ formatMetricDisplay(payInfo.total_pay_order_gmv_for_roi2) }}
          <!-- <div class="icon2_box pl5">
            <i class="el-icon-caret-bottom"></i>
            56%
          </div> -->
        </div>
        <div class="metric-detail-link" @click.stop="navigateToCostOverview('amount')">详情</div>
      </div>
      <div class="balance account_box">
        <div class="flex pb10 alcenter">
          整体成交订单数
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">全域推广产品投放期间，推广商品在推广渠道下产<br />生的成交订单数
              （包含非预售订单的成交单数和预<br />售订单已完成尾款支付单数，不包含预售订单未<br />完成尾款支付单数以及直播间内的商品成交订单）
            </div>
            <i class="el-icon-question pt5 ml10"></i>
          </el-tooltip>
        </div>
        <div class="font-bold fs22 flex alcenter">
          {{ formatMetricDisplay(payInfo.total_pay_order_count_for_roi2, 0) }}
          <!-- <div class="icon2_box pl5">
            <i class="el-icon-caret-bottom"></i>
            66.67%
          </div> -->
        </div>
        <div class="metric-detail-link metric-detail-link--placeholder">详情</div>
      </div>
      <div class="balance account_box">
        <div class="flex pb10 alcenter">
          整体成交订单成本
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">全域推广产品投放期间，全域推广消耗/整体成交
              <br />订单数
            </div>
            <i class="el-icon-question pt5 ml10"></i>
          </el-tooltip>
        </div>
        <div class="font-bold fs22 flex alcenter">
          {{ formatMetricDisplay(payInfo.total_cost_per_pay_order_for_roi2) }}
          <!-- <div class="icon2_box icon3_box pl5">
            <i class="el-icon-caret-top"></i>
            2.15%
          </div> -->
        </div>
        <div class="metric-detail-link metric-detail-link--placeholder">详情</div>
      </div>
      <div class="balance account_box">
        <div class="flex pb10 alcenter">
          整体成交订智能优惠券金额
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">在全域推广中启用[智能优惠券]功能后，成交订
              <br />单中被智能优惠券抵扣掉的金额
            </div>
            <i class="el-icon-question pt5 ml10"></i>
          </el-tooltip>
        </div>
        <div class="font-bold fs22 flex alcenter">
          {{ formatMetricDisplay(payInfo.total_pay_order_coupon_amount_for_roi2) }}
          <!-- <div class="icon2_box icon3_box pl5">
            <i class="el-icon-caret-top"></i>
            2.15%
          </div> -->
        </div>
        <div class="metric-detail-link metric-detail-link--placeholder">详情</div>
      </div>
    </div>
    <div class="uniPromotion-table">
      <common-table :limitHeight="true" pageName="UniPromotion" :advertiserId="advertiserId"
        :advertiserName="adAccountName" :table-columns="tableColumns" :url="url" :operate="operate"
        :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs"
        :before-get-data="beforeUniPromotionTableGetData" @returnADId="returnId"
        ref="table" @show-suggestion="handleShowSuggestion"
        @data-loaded="onUniPromotionDataLoaded"></common-table>
    </div>

    <el-dialog title="审核建议" :visible.sync="suggestionDialogVisible" width="50%" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
      <div v-if="currentSuggestionData && currentSuggestionData.length > 0">
        <div v-for="(item, index) in currentSuggestionData" :key="index" class="mb20 pb20 flex" style="border-bottom: 1px dashed #eee;">
          <!-- Left side: Image and details -->
          <div style="width: 140px; margin-right: 20px; flex-shrink: 0;" class="flex">
            <div>
              <el-image
                v-if="item.matchedProduct && item.matchedProduct.productImage"
                :src="item.matchedProduct.productImage"
                style="width: 60px; height: 60px; border-radius: 4px;"
                :preview-src-list="[item.matchedProduct.productImage]">
              </el-image>
              <el-image
                v-else-if="item.video_material && item.video_material.cover_image && item.video_material.cover_image.image_url"
                :src="item.video_material.cover_image.image_url"
                style="width: 60px; height: 60px; border-radius: 4px;"
                :preview-src-list="[item.video_material.cover_image.image_url]">
              </el-image>
              <el-image
                v-else-if="item.image_material && item.image_material.image_url"
                :src="item.image_material.image_url"
                style="width: 60px; height: 60px; border-radius: 4px;"
                :preview-src-list="[item.image_material.image_url]">
              </el-image>
              <div v-else style="width: 60px; height: 60px; background: #f5f5f5; border-radius: 4px;" class="flex-center c_999 fs12">无图</div>
            </div>

            <div class="ml10">
              <div class="font-bold fs14 mb5">
                <span v-if="item.matchedProduct">商品</span>
                <span v-else-if="item.video_material">视频</span>
                <span v-else>素材</span>
                <span class="c_999 fs12 font-normal ml5" style="border-left: 1px solid #ddd; padding-left: 5px;">广告审核</span>
              </div>
              <div class="c_999 fs12 overflow1" style="width: 70px;" :title="item.matchedProduct ? item.matchedProduct.productId : (item.material_id || '')">
                ID: {{ item.matchedProduct ? item.matchedProduct.productId : (item.material_id || '暂无') }}
              </div>
            </div>
          </div>

          <!-- Right side: Reject reasons and specific image -->
          <div style="flex: 1;">
            <div class="mb10">
              <span class="font-bold">拒审理由：</span>
              <span v-for="(reason, rIdx) in item.audit_reason" :key="'r'+rIdx"
                    style="color: #ff4949; background-color: #ffeded; border: 1px solid #ffdbdb; padding: 2px 6px; border-radius: 4px; font-size: 12px; margin-right: 5px;">
                {{ reason }}
              </span>
            </div>
            <div class="c_333 fs14 mb10">
              <span class="font-bold">违规详情：</span>{{ item.desc || '具体见违规点' }}
            </div>

            <!-- Deduplicate violation image from main thumbnail if both exist -->
            <div v-if="item.image_material && item.image_material.image_url &&
                      !(item.matchedProduct && item.matchedProduct.productImage === item.image_material.image_url)"
                 class="mt10 flex alcenter">
               <span class="c_999 fs12 mr10">违规图: </span>
               <el-image :src="item.image_material.image_url" style="width: 40px; height: 40px; border-radius: 4px; border: 1px solid #eee;" :preview-src-list="[item.image_material.image_url]"></el-image>
            </div>
            <div v-else-if="item.video_material && item.video_material.cover_image && item.video_material.cover_image.image_url &&
                           !(item.matchedProduct && item.matchedProduct.productImage === item.video_material.cover_image.image_url)"
                 class="mt10 flex alcenter">
               <span class="c_999 fs12 mr10">违规图: </span>
               <el-image :src="item.video_material.cover_image.image_url" style="width: 40px; height: 40px; border-radius: 4px; border: 1px solid #eee;" :preview-src-list="[item.video_material.cover_image.image_url]"></el-image>
            </div>

            <div class="mt10 c_999 fs12">
              <i class="el-icon-info mr5"></i>请前往对应管理处修改。商品完成上架/修改后，系统会在后续轮次重新检测。
            </div>
          </div>

          <!-- Optional actions -->
          <div style="width: 80px; text-align: right;" class="fs13" v-if="false">
             <div class="c_primary cp mb10">手动修改</div>
             <div class="c_primary cp">重新送审</div>
          </div>
        </div>
      </div>
      <div v-else class="text-center c_999 py20">
        暂无建议详情
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="suggestionDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";
export default {
  name: 'UniPromotion',
  components: { CommonTable },
  created() {
    this.resetDateRangeToToday()
    this.updateTime = this.getCurrentTime(1)
    this.getADAccountList()
    this.getAdvertiserGroupList()
    // this.statusName('DISABLE')
    // console.log(this.statusName('DISABLE'))
  },
  activated() {
    this.handleQuickEntry(this.$route)
  },
  data() {
    return {
      suggestionDialogVisible: false,
      currentSuggestionData: [],
      getDataParams: {
        startTime: "",
        endTime: "",
        id: null,
        groupId: null
      },
      advertiserId: 0,
      showSelectPopup: false,
      selectPopupIndex: null,
      searchADAccount: null,
      adAccountName: null,
      searchADAccountList: [],
      ADAccountList: [],
      searchADAccountTimer: null,
      searchADAccountRequestId: 0,
      ADAccountScrollPage: 1,
      ADAccountScrollHasMore: true,
      ADAccountScrollLoading: false,
      searchADAccountScrollPage: 1,
      searchADAccountScrollHasMore: true,
      searchADAccountScrollLoading: false,
      selectedGroupId: null,
      advertiserGroupList: [],
      groupListLoading: false,
      updateTime: null,
      planSyncState: 'READY',
      planDataComplete: true,
      planSyncPollTimer: null,
      planSyncPollAttempts: 0,
      planSyncMaxPollAttempts: 30,
      balance: null,
      selectData: null,
      lastValidSelectData: null,
      maxSelectableDays: 30,
      pickerOptions: {
        disabledDate(time) {
          const today = new Date()
          today.setHours(23, 59, 59, 999)
          const earliest = new Date()
          earliest.setHours(0, 0, 0, 0)
          earliest.setDate(earliest.getDate() - 29)
          return time.getTime() < earliest.getTime() || time.getTime() > today.getTime()
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setHours(0, 0, 0, 0);  // 今天00:00:00
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date();
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);  // 昨天23:59:59.999
            const start = new Date(end);
            start.setHours(0, 0, 0, 0);  // 昨天00:00:00
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近3天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 2);  // 3天前（含今天）
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 6);  // 7天前（含今天）
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近15天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 14);  // 15天前（含今天）
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 29);  // 30天前（含今天）
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上周',
          onClick(picker) {
            const today = new Date();
            const day = today.getDay(); // 本周的第几天（0=周日）
            const diff = day === 0 ? 6 : day - 1; // 到上周一的天数差

            const end = new Date(today);
            end.setDate(today.getDate() - diff - 1); // 上周日
            end.setHours(23, 59, 59, 999);

            const start = new Date(end);
            start.setDate(end.getDate() - 6); // 上周一
            start.setHours(0, 0, 0, 0);

            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '本月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(1);  // 本月1号
            start.setHours(0, 0, 0, 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上月',
          onClick(picker) {
            const end = new Date();
            end.setMonth(end.getMonth(), 0);  // 上月最后一天
            end.setHours(23, 59, 59, 999);

            const start = new Date(end);
            start.setDate(1);  // 上月1号
            start.setHours(0, 0, 0, 0);

            picker.$emit('pick', [start, end]);
          }
        }]
      },
      payInfo: {},
      selectIds: [],
      searchs: [],
      dialogVisible: false,
      detailData: {
        // 可以在这里初始化默认数据
        adId: '',
        awemeId: '',
        createTime: '',
        modifyTime: '',
        optStatus: '',
        status: '',
        name: '',
        marketingGoal: '',
        deliverySetting: {
          budgetMode: '',
          budget: '',
          startTime: '',
          endTime: '',
          smartBidType: '',
          roi2Goal: ''
        },
        multiProductCreativeList: []
      },
      visible: false,
      advertiserList: [],
      updateForm: {
        advertiserId: '',
        startTime: '',
        endTime: ''
      },
      permission: {
        // add: 'uniPromotion:add',
        // update: 'uniPromotion:update',
        // delete: 'uniPromotion:delete',
        deleteBatch: 'uniPromotion:deleteBatch'
      },
      url: {
        get: '/uniPromotion/listByCondition',
        // add: '/uniPromotion/add',
        // update: '/uniPromotion/update',
        // delete: '/uniPromotion/delete',
        delete_batch: '/uniPromotion/deleteBatch',
        status: '/uniPromotion/updateAdStatus',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: false,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: false
        /* show: {
           type: 'select',
         },*/
      }, {
        field: 'advertiserId',  // 字段名
        label: '计划名称',  // 字段显示名称
        sort: false,  // 是否排序
        type: 'planName',
        selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
        valueKey: 'advertiserId',
        selectData: [],
        show: true,  // 是否展示,
        width: 380
      }, {
        field: 'aweMeId',  // 字段名
        label: '计划状态',  // 字段显示名称
        sort: false,  // 是否排序
        type: 'planStatus',
        show: true,  // 是否展示,
        width: 200
      }, {
        field: 'adId',  // 字段名
        label: '推广设置',  // 字段显示名称
        sort: false,  // 是否排序
        type: 'promotionSettings',
        show: true,  // 是否展示
      }, {
        field: 'name',  // 字段名
        label: '操作',  // 字段显示名称
        sort: false,  // 是否排序
        type: 'operation',
        show: true,  // 是否展示
        width: 100
      }, {
        field: 'budget',  // 字段名
        label: '抖音号信息',  // 字段显示名称
        sort: false,  // 是否排序
        type: 'dyInfo',
        show: true,  // 是否展示
        width: 300
      }, {
        field: 'budgetMode',  // 字段名
        label: '商品信息',  // 字段显示名称
        sort: false,  // 是否排序
        type: 'goodsInfo',
        show: true,
        width: 300
      }, {
        field: 'statCost',  // 字段名
        label: '整体消耗(元)',  // 字段显示名称
        sort: true,  // 是否排序
        // type: 'goodsInfo',
        show: true,  // 是否展示
        sortable: 'custom',
        width: 180
      }, {
        field: 'totalPrepayAndPayOrderRoi2',  // 字段名
        label: '整体支付ROI',  // 字段显示名称
        sort: true,  // 是否排序
        show: true,  // 是否展示
        sortable: 'custom',
        width: 180
      }, {
        field: 'totalPayOrderGmvForRoi2',  // 字段名
        label: '用户实际支付金额(元)',  // 字段显示名称
        sort: true,  // 是否排序
        show: true,  // 是否展示
        sortable: 'custom',
        width: 190
      }, {
        field: 'totalPayOrderCountForRoi2',  // 字段名
        label: '整体成交订单数',  // 字段显示名称
        sort: true,  // 是否排序
        show: true,  // 是否展示
        sortable: 'custom',
        width: 190
      }, {
        field: 'totalCostPerPayOrderForRoi2',  // 字段名
        label: '整体成交订单成本',  // 字段显示名称
        sort: true,  // 是否排序
        show: true,  // 是否展示
        sortable: 'custom',
        width: 190
      }],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        toTree: false,
        model: [{
          field: 'id',  // 字段名
          label: 'ID',  // 字段显示名称
          type: 'input',
          add: false,  // 是否添加
          update: true
        },
        {
          field: 'agentId',  // 字段名
          label: 'agentId',  // 字段显示名称
          type: 'input',
          placeholder: '请输入agentId',
          rules: [
            { required: true, message: 'agentId不能为空', trigger: 'blur' }
          ],
          add: false,
          update: false,
        }, {
          field: 'advertiserId',  // 字段名
          label: 'advertiserId',  // 字段显示名称
          type: 'input',
          placeholder: '请输入advertiserId',
          rules: [
            { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
          ],
          add: false,
          update: false,
        }, {
          field: 'aweMeId',  // 字段名
          label: 'aweMeId',  // 字段显示名称
          type: 'input',
          placeholder: '请输入aweMeId',
          rules: [
            { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
          ],
          add: false,
          update: false,
        }, {
          field: 'adId',  // 字段名
          label: '推广ID',  // 字段显示名称
          type: 'input',
          placeholder: '请输入adId',
          rules: [
            { required: true, message: 'adId不能为空', trigger: 'blur' }
          ],
          add: false,
          update: false,
        }, {
          field: 'name',  // 字段名
          label: '推广名称',  // 字段显示名称
          type: 'input',
          placeholder: '请输入name',
          rules: [
            { required: true, message: 'name不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'budget',  // 字段名
          label: 'budget',  // 字段显示名称
          type: 'input',
          placeholder: '请输入budget',
          rules: [
            { required: true, message: 'budget不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'budgetMode',  // 字段名
          label: 'budgetMode',  // 字段显示名称
          type: 'input',
          placeholder: '请输入budgetMode',
          rules: [
            { required: true, message: 'budgetMode不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'adCreateTime',  // 字段名
          label: 'adCreateTime',  // 字段显示名称
          type: 'input',
          placeholder: '请输入adCreateTime',
          rules: [
            { required: true, message: 'adCreateTime不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'dailyDeliveryTime',  // 字段名
          label: 'dailyDeliveryTime',  // 字段显示名称
          type: 'input',
          placeholder: '请输入dailyDeliveryTime',
          rules: [
            { required: true, message: 'dailyDeliveryTime不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'deliverySeconds',  // 字段名
          label: 'deliverySeconds',  // 字段显示名称
          type: 'input',
          placeholder: '请输入deliverySeconds',
          rules: [
            { required: true, message: 'deliverySeconds不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'marketingGoal',  // 字段名
          label: 'marketingGoal',  // 字段显示名称
          type: 'input',
          placeholder: '请输入marketingGoal',
          rules: [
            { required: true, message: 'marketingGoal不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'modifyTime',  // 字段名
          label: 'modifyTime',  // 字段显示名称
          type: 'input',
          placeholder: '请输入modifyTime',
          rules: [
            { required: true, message: 'modifyTime不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'optStatus',  // 字段名
          label: 'optStatus',  // 字段显示名称
          type: 'input',
          placeholder: '请输入optStatus',
          rules: [
            { required: true, message: 'optStatus不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'roi2Goal',  // 字段名
          label: 'roi2Goal',  // 字段显示名称
          type: 'input',
          placeholder: '请输入roi2Goal',
          rules: [
            { required: true, message: 'roi2Goal不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'smartBidType',  // 字段名
          label: 'smartBidType',  // 字段显示名称
          type: 'input',
          placeholder: '请输入smartBidType',
          rules: [
            { required: true, message: 'smartBidType不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'status',  // 字段名
          label: 'status',  // 字段显示名称
          type: 'input',
          placeholder: '请输入status',
          rules: [
            { required: true, message: 'status不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'startTime',  // 字段名
          label: 'startTime',  // 字段显示名称
          type: 'input',
          placeholder: '请输入startTime',
          rules: [
            { required: true, message: 'startTime不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'endTime',  // 字段名
          label: 'endTime',  // 字段显示名称
          type: 'input',
          placeholder: '请输入endTime',
          rules: [
            { required: true, message: 'endTime不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'roomInfo',  // 字段名
          label: 'roomInfo',  // 字段显示名称
          type: 'input',
          placeholder: '请输入roomInfo',
          rules: [
            { required: true, message: 'roomInfo不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'statsInfo',  // 字段名
          label: 'statsInfo',  // 字段显示名称
          type: 'input',
          placeholder: '请输入statsInfo',
          rules: [
            { required: true, message: 'statsInfo不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'productInfo',  // 字段名
          label: 'productInfo',  // 字段显示名称
          type: 'input',
          placeholder: '请输入productInfo',
          rules: [
            { required: true, message: 'productInfo不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }]
      },
      operate: [],
      buttons: [{
        icon: 'el-icon-plus',
        type: 'primary',
        text: '新建计划',
        permission: 'uniPromotion:delete',
        click: () => {
          if (this.isAllAccountSelected) {
            this.$message.warning('全部视图仅支持查询，请先切换到具体店铺后再新建计划')
            return
          }
          this.$router.push({
            path: '/qdd/admin/UniPromotionNew.html',
            query: {
              id: this.advertiserId,
              name: this.adAccountName,
            }
          })
        }
      }, {
        icon: 'el-icon-video-play',
        type: 'primary',
        text: '批量启用',
        permission: 'uniPromotion:delete',
        click: () => {
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要批量启用的数据')
            return
          }
          this.changeDataStatus(1)
        }
      }, {
        icon: 'el-icon-video-pause',
        type: 'primary',
        text: '批量暂停',
        permission: 'uniPromotion:delete',
        click: () => {
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要暂停的数据')
            return
          }
          this.changeDataStatus(0)
        }
      }]
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        this.handleQuickEntry(route)
      }
    },
    getDataParams: {
      immediate: true,
      deep: true,
      handler(newVal) {
        console.log(newVal, 'change')
        if (newVal.startTime && newVal.endTime && newVal.id && Number(newVal.id) > 0) {
          this.payInfo = {}
          this.getAllPayInfo()
        } else {
          this.payInfo = {}
        }
        if (newVal.id && Number(newVal.id) > 0) {
          this.balance = null
          this.getBalance()
        }
        if (newVal.id && Number(newVal.id) <= 0) {
          this.balance = '--'
        }
      }
    },

  },
  beforeDestroy() {
    if (this.searchADAccountTimer) {
      clearTimeout(this.searchADAccountTimer)
    }
    this.stopPlanSyncPolling()
  },
  computed: {
    planSyncBannerVisible() {
      return this.planDataComplete === false
        || this.planSyncState === 'SYNCING'
        || this.planSyncState === 'TEMP_YESTERDAY'
        || this.planSyncState === 'FAILED'
    },
    planSyncBannerText() {
      if (this.planSyncState === 'FAILED') {
        return '计划全量同步失败，正在自动重试；当前列表可能不完整'
      }
      if (this.planSyncState === 'SYNCING') {
        return '正在同步官方全域计划，完成后将自动刷新列表'
      }
      return '数据正在同步，请稍候'
    },
    isAllAccountSelected() {
      return Number(this.getDataParams.id) <= 0 && Number(this.advertiserId) <= 0
    },
    creativeTypeMapping() {
      return {
        PROGRAMMATIC_CREATIVE: '程序化创意'
        // 后续可扩展其他类型
      }
    },
    optStatusName() {
      const statusMap = {
        ENABLE: '启用',
        DISABLE: '暂停',
        DELETE: '删除',
        QUOTA_DISABLE: '因在设计划痕后被忽略而暂停',
        ROIZ_DISABLE: '因设计划痕后的抖音号开启全域推广，因此本计划被系统暂停',
        SYSTEM_DISABLE: '系统暂停，因低效计划被系统自动暂停'
      }
      return statusMap[this.detailData.optStatus] || this.detailData.optStatus
    },
    budgetModeOptions() {
      return [
        { id: 'BUDGET_MODE_DAY', name: '日预算' },
        { id: 'BUDGET_MODE_TOTAL', name: '总预算' }
      ]
    },
    budgetModeName() {
      const found = this.budgetModeOptions.find(
        item => item.id === this.detailData.deliverySetting.budgetMode
      )
      return found ? found.name : this.detailData.deliverySetting.budgetMode
    },
    marketingGoalName() {
      const marketingGoalMapping = {
        LIVE_PROM_GOODS: '推直播间',
        VIDEO_PROM_GOODS: '推商品'
      }
      return marketingGoalMapping[this.detailData.marketingGoal]
        || this.detailData.marketingGoal
    },
    videoScheduleTypeName() {
      const videoScheduleTypeMapping = {
        SCHEDULE_FROM_NOW: '从今天起长期投放',
        SCHEDULE_START_END: '设置开始和结束日期 '
      }
      return videoScheduleTypeMapping[this.detailData.deliverySetting.videoScheduleType]
        || this.detailData.deliverySetting.videoScheduleType
    },
    qcpxModeName() {
      const qcpxModeMapping = {
        QCPX_MODE_DEFAULT: '未启用',
        QCPX_MODE_OFF: '关闭 ',
        QCPX_MODE_ON: '开启'
      }
      return qcpxModeMapping[this.detailData.deliverySetting.qcpxMode]
        || this.detailData.deliverySetting.qcpxMode
    }
  },
  methods: {
    isQuickEntryRoute(route) {
      return route && route.name === 'UniPromotion' && route.query && route.query.quickSource === 'engineIndex'
    },
    getQuickEntryAccountSelection(route) {
      if (!this.isQuickEntryRoute(route) || !this.ADAccountList || !this.ADAccountList.length) {
        return null
      }
      if (route.query.quickSelectMode === 'all') {
        return {
          account: this.ADAccountList[0],
          index: 0
        }
      }
      if (route.query.quickSelectFirst === 'true') {
        return {
          account: this.ADAccountList[1] || this.ADAccountList[0],
          index: this.ADAccountList[1] ? 1 : 0
        }
      }
      return null
    },
    handleQuickEntry(route) {
      if (!this.isQuickEntryRoute(route)) return
      if (route.query.quickDate === 'today') {
        this.resetDateRangeToToday()
      }
      const quickSelection = this.getQuickEntryAccountSelection(route)
      if (quickSelection) {
        this.applySelectedAdvertiser(quickSelection.account, quickSelection.index)
      }
    },
    resetDateRangeToToday() {
      const startTime = this.getCurrentTime()
      const endTime = this.getCurrentTime(1)
      this.getDataParams = Object.assign({}, this.getDataParams, {
        startTime,
        endTime
      })
      this.selectData = [new Date(startTime), new Date(endTime)]
      this.lastValidSelectData = this.cloneDateRange(this.selectData)
    },
    cloneDateRange(range) {
      if (!Array.isArray(range) || range.length !== 2 || !range[0] || !range[1]) {
        return null
      }
      return [new Date(range[0]), new Date(range[1])]
    },
    getEarliestSelectableDate() {
      const earliest = new Date()
      earliest.setHours(0, 0, 0, 0)
      earliest.setDate(earliest.getDate() - (this.maxSelectableDays - 1))
      return earliest
    },
    isDateRangeWithinLimit(range) {
      if (!Array.isArray(range) || range.length !== 2 || !range[0] || !range[1]) {
        return false
      }
      const startDate = new Date(range[0])
      const endDate = new Date(range[1])
      const earliest = this.getEarliestSelectableDate()
      const today = new Date()
      today.setHours(23, 59, 59, 999)
      return startDate.getTime() >= earliest.getTime() &&
        endDate.getTime() <= today.getTime() &&
        startDate.getTime() <= endDate.getTime()
    },
    restoreLastValidDateRange() {
      const fallbackRange = this.cloneDateRange(this.lastValidSelectData)
      if (!fallbackRange) {
        this.resetDateRangeToToday()
        return
      }
      this.selectData = fallbackRange
      this.syncDateRangeToParams(fallbackRange)
    },
    syncDateRangeToParams(range) {
      if (!Array.isArray(range) || range.length !== 2 || !range[0] || !range[1]) {
        this.getDataParams.startTime = ''
        this.getDataParams.endTime = ''
        return
      }
      const startDate = new Date(range[0])
      const endDate = new Date(range[1])
      const year_start = startDate.getFullYear()
      const month_start = String(startDate.getMonth() + 1).padStart(2, '0')
      const day_start = String(startDate.getDate()).padStart(2, '0')
      this.getDataParams.startTime = `${year_start}-${month_start}-${day_start} 00:00:00`
      this.getDataParams.endTime = this.processDate(endDate)
    },
    triggerUniPromotionTableSearch() {
      this.$nextTick(() => {
        if (this.$refs.table && this.$refs.table.handleSearch) {
          this.$refs.table.handleSearch()
        }
      })
    },
    beforeUniPromotionTableGetData(condition) {
      if (!condition) {
        return true
      }
      condition.startTime = this.getDataParams && this.getDataParams.startTime ? this.getDataParams.startTime : ''
      condition.endTime = this.getDataParams && this.getDataParams.endTime ? this.getDataParams.endTime : ''
      if (condition.id !== undefined) { delete condition.id }
      const normalizedGroupId = this.normalizeGroupId(this.selectedGroupId || (this.getDataParams && this.getDataParams.groupId))
      if (normalizedGroupId) {
        condition.groupId = normalizedGroupId
      } else {
        delete condition.groupId
      }
      return true
    },
    applySelectedAdvertiser(account, index) {
      if (!account) return
      this.stopPlanSyncPolling()
      this.planSyncState = 'READY'
      this.planDataComplete = true
      let nextGroupId = this.normalizeGroupId(this.selectedGroupId)
      if (Number(account.id) <= 0) {
        this.resetDateRangeToToday()
      } else if (nextGroupId) {
        nextGroupId = null
        this.selectedGroupId = null
        this.syncGroupFilterToTable(null)
      }
      this.selectPopupIndex = index
      this.getDataParams = Object.assign({}, this.getDataParams, {
        id: account.id,
        groupId: nextGroupId
      })
      this.advertiserId = account.advertiserId
      this.adAccountName = account.name
      this.showSelectPopup = false
      this.searchADAccount = null
      this.searchADAccountList = []
      this.triggerUniPromotionTableSearch()
    },
    normalizeGroupId(groupId) {
      if (groupId === undefined || groupId === null || groupId === '') {
        return null
      }
      const normalizedGroupId = Number(groupId)
      if (isNaN(normalizedGroupId) || normalizedGroupId <= 0) {
        return null
      }
      return normalizedGroupId
    },
    syncGroupFilterToTable(groupId) {
      if (!this.$refs.table) {
        return
      }
      this.$set(this.$refs.table.query, 'groupId', groupId || '')
    },
    handleGroupChange(groupId) {
      const normalizedGroupId = this.normalizeGroupId(groupId)
      this.selectedGroupId = normalizedGroupId
      this.syncGroupFilterToTable(normalizedGroupId)
      if (normalizedGroupId && !this.isAllAccountSelected && this.ADAccountList && this.ADAccountList.length) {
        this.$message.info('已切换到全部视图，按当前分组查询计划')
        this.applySelectedAdvertiser(this.ADAccountList[0], 0)
      } else {
        this.getDataParams = Object.assign({}, this.getDataParams, {
          groupId: normalizedGroupId
        })
      }
      this.$nextTick(() => {
        if (this.$refs.table && this.$refs.table.handleSearch) {
          this.$refs.table.handleSearch()
        }
      })
    },
    handleShowSuggestion(payload) {
      console.log('handleShowSuggestion initiated with payload:', payload);
      const data = payload.suggestionData;
      const productInfo = payload.productInfo || [];
      if (!data || data.length === 0) {
        console.warn("No suggestion data found in payload.");
        this.$message.warning("暂无详细建议数据");
        return;
      }

      // Map product info if present
      const mappedData = data.map(item => {
        let matchedProduct = null;
        if (item.product_id) {
          matchedProduct = productInfo.find(p => p.productId == item.product_id);
        }
        return {
          ...item,
          matchedProduct
        };
      });

      console.log('Mapped suggestion data:', mappedData);
      this.currentSuggestionData = mappedData;
      this.suggestionDialogVisible = true;
    },
    buildCostOverviewRouteQuery(metricType) {
      const query = {
        autoOpenDetail: '1',
        metricType: metricType || 'consumption',
        _t: String(Date.now())
      }
      if (this.getDataParams && this.getDataParams.startTime) {
        query.startDate = this.getDataParams.startTime.substring(0, 10)
      }
      if (this.getDataParams && this.getDataParams.endTime) {
        query.endDate = this.getDataParams.endTime.substring(0, 10)
      }
      const normalizedGroupId = this.normalizeGroupId(this.selectedGroupId || (this.getDataParams && this.getDataParams.groupId))
      if (normalizedGroupId) {
        query.groupId = String(normalizedGroupId)
      }
      if (!this.isAllAccountSelected && this.advertiserId) {
        query.advertiserId = String(this.advertiserId)
      }
      return query
    },
    navigateToCostOverview(metricType) {
      if (!this.getDataParams.startTime || !this.getDataParams.endTime) {
        this.$message.warning('请先选择时间范围后再查看详情')
        return
      }
      this.$router.push({
        path: '/qdd/admin/QianchuanCostOverview.html',
        query: this.buildCostOverviewRouteQuery(metricType)
      })
    },
    beforeUniPromotionListQuery() {
      const advertiserId = Number(this.advertiserId)
      if (!advertiserId || advertiserId <= 0) {
        return Promise.resolve(true)
      }
      const cachedState = this.backfillStateByAdvertiser[advertiserId]
      if (cachedState && cachedState.status === 'success') {
        return Promise.resolve(true)
      }
      if (cachedState && cachedState.promise) {
        return cachedState.promise
      }
      const createEndDate = this.formatDateOnly(new Date())
      const requestData = {
        advertiserId,
        createStartDate: '2020-01-01',
        createEndDate
      }
      const requestPromise = new Promise((resolve, reject) => {
        this.$axios.post({
          url: '/uniPromotion/backfillSingleAdvertiser',
          data: requestData,
          loading: false,
          success: (res) => {
            if (res.code === 0) {
              this.$set(this.backfillStateByAdvertiser, advertiserId, {
                status: 'success',
                finishedAt: createEndDate
              })
              resolve(true)
              return
            }
            this.$delete(this.backfillStateByAdvertiser, advertiserId)
            this.$message.error(res.msg || '本地计划回补失败')
            reject(new Error(res.msg || 'backfill failed'))
          },
          error: (error) => {
            this.$delete(this.backfillStateByAdvertiser, advertiserId)
            this.$message.error('本地计划回补失败')
            reject(error)
          }
        })
      })
      this.$set(this.backfillStateByAdvertiser, advertiserId, {
        status: 'pending',
        promise: requestPromise
      })
      return requestPromise
    },
    statusName(name) {
      const statusMapping = {
        DELETED: '已删除',
        AUDIT: '新建审核中',
        TIME_DONE: '已完成',
        DISABLE: '已暂停',
        TIME_NO_REACH: '未到达投放时间',
        OFFLINE_BALANCE: '账户余额不足',
        OFFLINE_BUDGET: '广告预算不足',
        DELIVERY_OK: '投放中',
        NO_SCHEDULE: '不在投放时段',
        REAUDIT: '修改审核中',
        OFFLINE_AUDIT: '审核不通过',
        EXTERNAL_URL_DISABLE: '落地页暂不可用',
        LIVE_ROOM_OFF: '关联直播间未开通',
        FROZEN: '已终止',
        SYSTEM_DISABLE: '系统暂停',
        ALL_INCLUDE_DELETED: '全部（包含已删除）',
        QUOTA_DISABLE: '在投计划配额超限',
        ROI2_DISABLE: '全域推广暂停'
      }
      return statusMapping[name]
    },
    refresh() {
      this.payInfo = {}
      this.balance = this.isAllAccountSelected ? '--' : null
      if (!this.isAllAccountSelected) {
        this.getAllPayInfo()
        this.getBalance()
      }
      this.$refs.table.getData()
    },
    onUniPromotionDataLoaded(payload) {
      const rawData = payload && payload.rawData ? payload.rawData : null
      const syncState = rawData && rawData.syncState ? rawData.syncState : 'READY'
      const dataComplete = rawData && rawData.dataComplete === false ? false : true
      this.planSyncState = syncState
      this.planDataComplete = dataComplete
      if (!dataComplete || syncState === 'SYNCING' || syncState === 'TEMP_YESTERDAY' || syncState === 'FAILED') {
        this.startPlanSyncPolling()
      } else {
        this.stopPlanSyncPolling()
      }
    },
    startPlanSyncPolling() {
      if (this.planSyncPollTimer) {
        return
      }
      this.planSyncPollAttempts = 0
      this.planSyncPollTimer = setInterval(() => {
        this.pollPlanSkeletonUntilReady()
      }, 2500)
    },
    stopPlanSyncPolling() {
      if (this.planSyncPollTimer) {
        clearInterval(this.planSyncPollTimer)
        this.planSyncPollTimer = null
      }
      this.planSyncPollAttempts = 0
    },
    pollPlanSkeletonUntilReady() {
      this.planSyncPollAttempts += 1
      if (this.planSyncPollAttempts > this.planSyncMaxPollAttempts) {
        this.stopPlanSyncPolling()
        return
      }
      const advertiserId = Number(this.advertiserId)
      if (!advertiserId || advertiserId <= 0) {
        this.stopPlanSyncPolling()
        return
      }
      const condition = {
        advertiserId,
        pageIndex: 1,
        pageSize: 10,
        startTime: this.getDataParams && this.getDataParams.startTime ? this.getDataParams.startTime : '',
        endTime: this.getDataParams && this.getDataParams.endTime ? this.getDataParams.endTime : '',
        marketingGoal: 'VIDEO_PROM_GOODS'
      }
      this.$axios.post({
        url: '/uniPromotion/listByCondition',
        data: condition,
        loading: false,
        success: (res) => {
          if (!res || res.code !== 0 || !res.data) {
            return
          }
          const syncState = res.data.syncState || 'READY'
          const dataComplete = res.data.dataComplete !== false
          this.planSyncState = syncState
          this.planDataComplete = dataComplete
          if (dataComplete && syncState === 'READY') {
            this.stopPlanSyncPolling()
            this.updateTime = this.getCurrentTime(1)
            if (this.$refs.table && typeof this.$refs.table.getData === 'function') {
              this.$refs.table.getData()
            }
          }
        },
        error: () => {}
      })
    },
    changeDataStatus(type) {
      if (this.isAllAccountSelected) {
        this.$message.warning('全部视图仅支持查询，请先切换到具体店铺后再执行批量操作')
        return
      }
      let type_word = '启用'
      let adIds = []
      if (type == 0) {
        type_word = '暂停'
        this.selectIds.forEach((obj) => {
          if (obj.status !== 'DISABLE') {
            adIds.push(obj.adId)
          }
        })
      } else if (type == 2) {
        type_word = '删除'
        this.selectIds.forEach((obj) => {
          if (obj.status !== 'DELETED') {
            adIds.push(obj.adId)
          }
        })
      } else if (type == 1) {
        this.selectIds.forEach((obj) => {
          if (obj.status !== 'DELIVERY_OK') {
            adIds.push(obj.adId)
          }
        })

      }
      console.log(this.selectIds)
      let data = { adId: adIds, optStatus: type, advertiserId: this.advertiserId }
      console.log(data, 'data')
      request.post({
        url: '/uniPromotion/updateAdStatus',
        data,
        confirm: '确定' + type_word + '选中的全域计划？',
        success: (data) => {
          if (data.code == 0) {
            this.$refs.table.getData()
            this.$message.success(type_word + '成功')
          } else {
            this.$message.error(data.msg || '出错了')
          }
        }
      });
    },
    processDate(targetDate) {
      const now = new Date();
      // 创建目标日期的纯日期部分（去除时间）
      const targetDateOnly = new Date(
        targetDate.getFullYear(),
        targetDate.getMonth(),
        targetDate.getDate()
      );

      // 创建当前日期的纯日期部分（去除时间）
      const todayOnly = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );

      console.log(targetDateOnly.getTime() === todayOnly.getTime(), now, '555555')
      if (targetDateOnly.getTime() === todayOnly.getTime()) {
        // 如果是今天：返回当前完整时间（年月日时分秒）

        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const day = String(now.getDate()).padStart(2, '0')
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const seconds = String(now.getSeconds()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      } else {
        const year_end = targetDate.getFullYear()
        const month_end = String(targetDate.getMonth() + 1).padStart(2, '0')
        const day_end = String(targetDate.getDate()).padStart(2, '0')
        return `${year_end}-${month_end}-${day_end} 23:59:59`
      }
    },
    // 使用示例
    pickData(e) {
      if (e) {
        const selectedRange = this.cloneDateRange(e)
        if (!this.isDateRangeWithinLimit(selectedRange)) {
          this.$message.warning(`最多只能查询最近 ${this.maxSelectableDays} 天的数据`)
          this.restoreLastValidDateRange()
          return
        }
        this.syncDateRangeToParams(selectedRange)
        this.lastValidSelectData = this.cloneDateRange(selectedRange)
      } else {
        this.selectData = null
        this.lastValidSelectData = null
        this.syncDateRangeToParams(null)
      }
      this.triggerUniPromotionTableSearch()
    },
    inputSearchDYNumber() {
      const keyword = this.searchADAccount ? String(this.searchADAccount).trim() : ''
      if (this.searchADAccountTimer) {
        clearTimeout(this.searchADAccountTimer)
      }
      this.searchADAccountRequestId += 1
      const currentRequestId = this.searchADAccountRequestId

      this.searchADAccountList = []
      this.searchADAccountScrollPage = 1
      this.searchADAccountScrollHasMore = true
      this.searchADAccountScrollLoading = false

      if (!keyword) {
        return
      }
      this.searchADAccountList = this.ADAccountList.filter((obj) => {
        const name = obj && obj.name ? String(obj.name) : ''
        const advertiserId = obj && obj.advertiserId !== undefined && obj.advertiserId !== null
          ? String(obj.advertiserId)
          : ''
        return name.includes(keyword) || advertiserId.includes(keyword)
      })
      this.searchADAccountTimer = setTimeout(() => {
        this.searchADAccountScrollLoading = true
        this.$axios.post({
          url: '/oceanEngineAdvertiser/optionsByCondition',
          data: {
            keyword,
            pageIndex: 1,
            pageSize: 30
          },
          loading: false,
          success: (res) => {
            if (currentRequestId !== this.searchADAccountRequestId) {
              return
            }
            this.searchADAccountScrollLoading = false
            if (res.code !== 0) { return }
            const payload = res.data || {}
            this.searchADAccountScrollHasMore = !!payload.hasMore
            const remoteList = payload.content || []
            const mergedMap = {}
            const mergedList = []
            this.searchADAccountList.concat(remoteList).forEach((item) => {
              if (!item) {
                return
              }
              const advertiserId = item.advertiserId !== undefined && item.advertiserId !== null
                ? String(item.advertiserId)
                : ''
              if (!advertiserId || mergedMap[advertiserId]) {
                return
              }
              mergedMap[advertiserId] = true
              mergedList.push(item)
            })
            this.searchADAccountList = mergedList
          },
          error: () => {
            this.searchADAccountScrollLoading = false
          }
        })
      }, 200)
    },
    goSelectDYNumber(index2) {
      const accountList = this.searchADAccount ? this.searchADAccountList : this.ADAccountList
      const account = accountList[index2]
      if (!account) return
      const selectedIndex = this.ADAccountList.findIndex((item) => {
        if (!item) {
          return false
        }
        if (item.id !== undefined && account.id !== undefined && String(item.id) === String(account.id)) {
          return true
        }
        return item.advertiserId !== undefined &&
          account.advertiserId !== undefined &&
          String(item.advertiserId) === String(account.advertiserId)
      })
      this.applySelectedAdvertiser(account, selectedIndex > -1 ? selectedIndex : index2)
    },
    isAllAdvertiserOption(account) {
      return !!(account && Number(account.id) <= 0)
    },
    isAdvertiserStatusError(account) {
      if (this.isAllAdvertiserOption(account)) {
        return false
      }
      return Number(account && account.accountStatus) !== 1
    },
    getAdvertiserStatusText(account) {
      if (this.isAllAdvertiserOption(account)) {
        return '授权正常'
      }
      return Number(account && account.accountStatus) === 1 ? '授权正常' : '授权异常'
    },
    gotoShowSelectPopup() {
      this.showSelectPopup = !this.showSelectPopup
      this.searchADAccount = null
      this.searchADAccountList = []
      this.searchADAccountRequestId += 1
      if (this.searchADAccountTimer) {
        clearTimeout(this.searchADAccountTimer)
      }
      this.searchADAccountScrollPage = 1
      this.searchADAccountScrollHasMore = true
      this.searchADAccountScrollLoading = false
    },
    getADAccountList() {
      this.ADAccountScrollPage = 1
      this.ADAccountScrollHasMore = true
      this.ADAccountScrollLoading = true
      this.$axios.post({
        url: '/oceanEngineAdvertiser/optionsByCondition',
        data: {
          pageIndex: 1,
          pageSize: 30
        },
        success: (res) => {
          this.ADAccountScrollLoading = false
          console.log('333', res)
          if (res.code === 0) {
            const payload = res.data || {}
            this.ADAccountScrollHasMore = !!payload.hasMore
            const accountList = payload.content || []
            this.ADAccountList = [{
              id: -1,
              advertiserId: -1,
              name: '全部（今日创建）'
            }].concat(accountList)
            if (this.ADAccountList && this.ADAccountList.length) {
              const quickSelection = this.getQuickEntryAccountSelection(this.$route)
              if (quickSelection) {
                this.applySelectedAdvertiser(quickSelection.account, quickSelection.index)
                return
              }
              if (!this.getDataParams.id) {
                this.applySelectedAdvertiser(this.ADAccountList[1] || this.ADAccountList[0], this.ADAccountList[1] ? 1 : 0)
              }
              console.log(this.getDataParams, 'this.getDataParams')
            }
          } else {
            this.$message.error(res.msg || '获取数据错误')
          }
        },
        error: () => {
          this.ADAccountScrollLoading = false
          this.$message.error('出错了')
        },
      })
    },
    handleADAccountListScroll(e) {
      const target = e.target
      if (target.scrollHeight - target.scrollTop <= target.clientHeight + 10) {
        this.loadNextADAccountPage()
      }
    },
    loadNextADAccountPage() {
      const keyword = this.searchADAccount ? String(this.searchADAccount).trim() : ''
      if (keyword) {
        if (!this.searchADAccountScrollHasMore || this.searchADAccountScrollLoading) {
          return
        }
        this.searchADAccountScrollLoading = true
        const nextPage = this.searchADAccountScrollPage + 1
        const currentRequestId = this.searchADAccountRequestId
        this.$axios.post({
          url: '/oceanEngineAdvertiser/optionsByCondition',
          data: {
            keyword,
            pageIndex: nextPage,
            pageSize: 30
          },
          loading: false,
          success: (res) => {
            if (currentRequestId !== this.searchADAccountRequestId) {
              return
            }
            this.searchADAccountScrollLoading = false
            if (res.code === 0) {
              const payload = res.data || {}
              const remoteList = payload.content || []
              this.searchADAccountScrollPage = nextPage
              this.searchADAccountScrollHasMore = !!payload.hasMore

              const mergedMap = {}
              const mergedList = []
              this.searchADAccountList.concat(remoteList).forEach((item) => {
                if (!item) return
                const advertiserId = item.advertiserId !== undefined && item.advertiserId !== null
                  ? String(item.advertiserId)
                  : ''
                if (!advertiserId || mergedMap[advertiserId]) return
                mergedMap[advertiserId] = true
                mergedList.push(item)
              })
              this.searchADAccountList = mergedList
            }
          },
          error: () => {
            this.searchADAccountScrollLoading = false
          }
        })
      } else {
        if (!this.ADAccountScrollHasMore || this.ADAccountScrollLoading) {
          return
        }
        this.ADAccountScrollLoading = true
        const nextPage = this.ADAccountScrollPage + 1
        this.$axios.post({
          url: '/oceanEngineAdvertiser/optionsByCondition',
          data: {
            pageIndex: nextPage,
            pageSize: 30
          },
          loading: false,
          success: (res) => {
            this.ADAccountScrollLoading = false
            if (res.code === 0) {
              const payload = res.data || {}
              const remoteList = payload.content || []
              this.ADAccountScrollPage = nextPage
              this.ADAccountScrollHasMore = !!payload.hasMore

              const mergedMap = {}
              const mergedList = [this.ADAccountList[0]].filter(Boolean)
              mergedList.forEach(item => {
                mergedMap[String(item.advertiserId)] = true
              })

              this.ADAccountList.slice(1).concat(remoteList).forEach((item) => {
                if (!item) return
                const advertiserId = item.advertiserId !== undefined && item.advertiserId !== null
                  ? String(item.advertiserId)
                  : ''
                if (!advertiserId || mergedMap[advertiserId]) return
                mergedMap[advertiserId] = true
                mergedList.push(item)
              })
              this.ADAccountList = mergedList
            }
          },
          error: () => {
            this.ADAccountScrollLoading = false
          }
        })
      }
    },
    getAdvertiserGroupList() {
      this.groupListLoading = true
      this.$axios.post({
        url: '/oceanEngineAdvertiserGroup/getAll',
        loading: false,
        success: (res) => {
          this.groupListLoading = false
          if (res.code === 0) {
            const groupList = (res.data && res.data.data) || res.data || []
            this.advertiserGroupList = Array.isArray(groupList) ? groupList : []
            return
          }
          this.$message.error(res.msg || '获取分组列表失败')
        },
        error: () => {
          this.groupListLoading = false
          this.$message.error('获取分组列表失败')
        },
      })
    },
    getCurrentTime(type) {
      const timestamp = Date.now()
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      if (type) {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      } else {
        return `${year}-${month}-${day} 00:00:00`
      }
    },
    formatDateOnly(date) {
      const targetDate = date instanceof Date ? date : new Date(date)
      const year = targetDate.getFullYear()
      const month = String(targetDate.getMonth() + 1).padStart(2, '0')
      const day = String(targetDate.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    formatMetricDisplay(value, scale = 2) {
      if (this.isAllAccountSelected) {
        return '--'
      }
      if (value === undefined || value === null || value === '') {
        return '--'
      }
      const numericValue = Number(value)
      if (!isFinite(numericValue)) {
        return value
      }
      if (scale <= 0) {
        return String(Math.round(numericValue))
      }
      const fixedValue = numericValue.toFixed(scale)
      return fixedValue
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1')
    },
    getBalance() {
      if (Number(this.getDataParams.id) <= 0) {
        this.balance = '--'
        return
      }
      this.$axios.get({
        url: '/uniPromotion/accountBalance/' + this.getDataParams.id,
        success: (res) => {
          console.log('getBalance', res)
          if (res.code === 0) {
            this.balance = res.data
          } else {
            this.$message.error(res.msg || '获取数据错误')
          }

        },
        error: () => {
          this.$message.error('获取数据错误')
        },
      })
    },
    getAllPayInfo() {
      console.log(this.getDataParams)
      this.$axios.post({
        url: '/uniPromotion/deliveryConsumption',
        data: this.getDataParams,
        success: (res) => {
          console.log('getAllPayInfo', res)
          // this.balance = res.data
          if (res.code === 0) {
            this.payInfo = res.data
          } else {
            this.$message.error(res.msg || '获取数据错误')
          }
        },
        error: () => {
          this.$message.error('出错了')
        },
      })
    },
    returnId(data) {
      this.selectIds = data;
      console.log(this.selectIds, 'this.selectIds')
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitBatch(formName) {
      // console.log(this.batchForm, "123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/uniPromotion/getAd',
            data: this.updateForm,
            success: (res) => {
              if (res.code === 0) {
                message.success("更新全域计划成功");
                this.visible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.uniPromotion_box {
  min-height: 100%;
  padding: 12px;
  background: linear-gradient(180deg, #f6f8fc 0%, #f8fbff 100%);
}

.uni-promotion-sync-alert {
  width: 100%;
  margin: 0 0 4px;
}

.uniPromotion_box .selectDataBox {
  padding: 12px 16px;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #e7edf8;
  box-shadow: 0 8px 22px rgba(31, 42, 68, 0.06);
}

.uniPromotion-toolbar {
  gap: 10px 12px;
}

.group-select {
  width: 220px;
}

.uniPromotion-metrics {
  margin-top: 10px;
  gap: 10px;
}

.update_box {
  color: #75839a;
  font-size: 13px;
  padding-right: 10px;
}

.account_box2 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d9e4f5;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
  min-height: 73px;
  width: 320px;
  transition: background .2s ease, border-color .2s ease;
}

.account_left_box {
  min-width: 0;
  flex: 1;
}

.accountNameBox {
  display: flex;
  align-items: center;
}

.accountNameBox .name {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.idBox {
  font-size: 13px;
}

.selectAdBox {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d9e4f5;
  border-radius: 10px;
  padding: 7px 12px;
  cursor: pointer;
  height: 34px;
  width: 220px;
  color: #8c98ae !important;
  margin-left: 12px;
  box-sizing: border-box;
  transition: border-color .2s ease, box-shadow .2s ease;
}

.selectAdBox:hover {
  border-color: #90b5ff;
  box-shadow: 0 0 0 2px rgba(52, 107, 246, 0.08);
}

.account_selector_popup_box {
  z-index: 100;
  padding: 14px;
  position: absolute;
  top: 44px;
  left: 0;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #e2eaf8;
  box-shadow: 0 10px 24px rgba(31, 42, 68, 0.14);
}

.number_top input {
  width: 250px;
}

.select_account_all_box {
  padding-top: 12px;
  max-height: 300px;
  overflow: auto;
}

.select_account_box {
  justify-content: flex-start;
}

.account_shop_box2 {
  color: #346bf6;
  background: rgba(67, 137, 249, 0.1);
  border-radius: 3px;
  padding: 3px 8px;
  line-height: 1;
}

.account_right_box2 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  margin-left: 12px;
}

.account_normal_box {
  color: #0adc7d;
  background: rgba(10, 220, 125, 0.1);
  padding: 3px 8px;
  border-radius: 3px;
  line-height: 1;
}

.account_normal_box--error {
  color: #f56c6c;
  background: rgba(245, 108, 108, 0.12);
}

.account_box:hover {
  border-color: #7fa8ff;
}

.account_box2:hover {
  background-color: #f1f6ff;
}

.accountPayInfo {
  font-size: 15px;
}

.accountPayInfo i {
  color: #c6d0e0;
  cursor: pointer;
}

.icon2_box,
.icon2_box i {
  font-size: 16px;
  color: #1cda8e;
}

.icon3_box,
.icon3_box i {
  color: #ff2020;
}

.icon2_box i {
  margin-right: -5px;
}

.accountPayInfo .account_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  padding: 12px;
  box-sizing: border-box;
  flex: 1 1 calc(14.2% - 10px);
  min-width: 176px;
  min-height: 94px;
  background: linear-gradient(180deg, #fbfdff 0%, #f5f8ff 100%);
  border: 1px solid #e6edfa;
  border-radius: 12px;
}

.accountPayInfo .account_box .fs22 {
  font-size: 20px;
  min-height: 28px;
  display: flex;
  align-items: center;
}

.metric-detail-link {
  margin-top: auto;
  min-height: 20px;
  display: flex;
  align-items: flex-end;
  color: #2f6ff5;
  font-size: 13px;
  cursor: pointer;
}

.metric-detail-link--placeholder {
  visibility: hidden;
  pointer-events: none;
}

.uniPromotion-table {
  margin-top: 10px;
}

.uniPromotion-table /deep/ .table-body {
  border-radius: 14px;
  border: 1px solid #e7edf8;
  box-shadow: 0 8px 22px rgba(31, 42, 68, 0.06);
  padding: 14px;
}

.uniPromotion-table /deep/ .table-tools {
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #edf2fb;
}

.uniPromotion-table /deep/ .table-tools .el-button--small {
  padding: 8px 11px;
  font-size: 12px;
}

@media (max-width: 768px) {
  .uniPromotion_box .selectDataBox {
    padding: 10px 12px;
  }

  .account_box {
    margin-bottom: 10px;
  }

  .update_box {
    padding-right: 0;
    padding-bottom: 6px;
  }

  .scaled-date-picker {
    transform: scale(0.86);
    margin-left: -22px;
  }

  .selectAdBox {
    margin-left: 0;
    margin-top: 8px;
    width: 100%;
    max-width: 260px;
  }

  .account_box2 {
    width: 260px;
  }

  .number_top input {
    width: 230px;
  }

  .accountPayInfo .account_box {
    width: 100%;
    min-width: 0;
    font-size: 13px;
  }
}
</style>
